import type { ChartConfiguration, ChartDataset } from 'chart.js/auto';
import { Chart as ChartJS } from 'chart.js/auto';
import { prepareGraphData } from 'containers/FlowProperties/util';
import type { PortInterface } from 'store/units/types';
import { getLineOptions } from 'util/getLineChartOptions';
import { store } from 'createStore';

interface GoJsGraphInterface {
  display: boolean;
  inputPorts: PortInterface[];
  outputPorts: PortInterface[];
  graphMode: string;
  psdCalcMode: string;
  activePortIndex: number;
  isFeed: boolean;
  ticks?: number[] | undefined;
}

export const GoJsFlowGraph = (
  graphData: GoJsGraphInterface,
  _picture: go.Picture,
) => {
  const canvases: any = document.getElementById('myCanvases');
  // prevent render if display is false
  if (!graphData.display) {
    return null;
  }

  const canv: HTMLCanvasElement = document.createElement('canvas');

  canv.width = 500;
  canv.height = 400;
  canv.getContext('2d', { willReadFrequently: true });

  const div = document.createElement('div');
  div.id = 'remove-id';
  div.style.position = 'absolute';

  div.appendChild(canv);
  canvases.appendChild(div);

  const { datasets, lowerLimit, upperLimit, convertedTicks } = prepareGraphData(
    graphData.outputPorts,
    graphData.inputPorts,
    graphData.graphMode,
    graphData.psdCalcMode,
    undefined,
    graphData.ticks,
    {
      isFeed: graphData.isFeed,
    },
  );

  const metricType = store.getState().settingsState.metricType;

  const lineOptions = getLineOptions({
    lowerLimit,
    upperLimit,
    smallestX: lowerLimit,
    biggestX: upperLimit,
    showGridLines: true,
    psdCalcMode: graphData.psdCalcMode,
    metricType,
    setLimits: () => {},
    ticks: convertedTicks,
  });

  const config: ChartConfiguration<'line'> = {
    type: 'line',
    data: { datasets: datasets as unknown as ChartDataset<'line'>[] },
    options: {
      ...lineOptions,
      animation: {
        duration: 0,
      },
    },
  };

  new ChartJS(canv, config);
  return canv;
};
